<template>
<div class="flex items-start justify-start relative">
  <on-click-outside v-show="showSearchInput" :handler="closeSearchInput"
    class="w-64 z-50 right-3 bg-white" :class="inMenu ? '' : 'absolute' ">
    <ais-instant-search
      :search-client="searchClient"
      index-name="products"
    >
      <ais-configure
        :hits-per-page.camel="7"
        :distinct="true"
        :restrict-searchable-attributes.camel="['description_'+$i18n.locale, 'sku', 'extended_description_'+$i18n.locale]"
      />
      <ais-autocomplete>
        <template slot-scope="{ indices, refine }">
          <vue-autosuggest
            :suggestions="indicesToSuggestions(indices)"
            @input="refine"
            @selected="openProductView"
            :input-props="{
                        style: 'width: 100%; outline:none; border-bottom: 1px solid gray; padding-rigt',
                        placeholder: $t('menu.search'),
                    }"
            :get-suggestion-value="getSuggestionValue"
          >
          <template slot-scope="{ suggestion }">
            <button @click="openProductView(suggestion.item['sku'])" class="px-4 py-2 w-84 bg-gray-100 text-left hover:bg-gray-200 hover:font-semibold">
                {{ suggestion.item['description_'+$i18n.locale] }}
            </button>
          </template>
          </vue-autosuggest>
        </template>
      </ais-autocomplete>
    </ais-instant-search>
  </on-click-outside>
  <button class="pr-4" @click="openSearchInput" :title="$t('menu.search')" :aria-label="$t('menu.search')">
    <search-icon></search-icon>
  </button>

</div>
</template>

<script>
import SearchIcon from '@/components/graphics/SearchIcon.vue';
import OnClickOutside from '@/directives/OnClickOutside';
import AlgoliaMixin from '@/mixins/AlgoliaMixin';
import { VueAutosuggest } from 'vue-autosuggest';

export default {
  props: ['inMenu'],

  data() {
    return {
      showSearchInput: false,

      selectedItem: null,
    };
  },

  components: {
    SearchIcon,
    OnClickOutside,
    VueAutosuggest,
  },

  mixins: [AlgoliaMixin],

  methods: {
    openSearchInput() {
      this.showSearchInput = !this.showSearchInput;
    },
    closeSearchInput() {
      this.showSearchInput = false;
    },

    openProductView(selected) {
      this.$emit('found');
      this.closeSearchInput();
      this.$router.push({ path: `/products/${selected.item.sku}` }).catch(() => {});
    },
  },
};
</script>
